import { TableCell, TableCellProps, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";

export type StyledTableCellProps = TableCellProps & {
  minWidth?: string;
  textAlign?: "left" | "center" | "right";
  backgroundColor?: "#FFDEDF" | "#DEFFE1" | "#FFFFFF" | "#ECECEC";
  fontColor?: "#e6292e" | "#343A40" | "#2190FF" | "#3E3F3F" | "#000000";
  hoverBackgroundColor?: string;
  noBorderTop?: boolean;
  noBorderBottom?: boolean;
  noBorderRight?: boolean;
  noBorderLeft?: boolean;
  fontSize?: string;
  fontWeight?: number;
};

const StyledInnerTableRow = styled(TableRow)(() => ({
  "& .MuiTableRow-root": {
    height: "36px",
  },
}));

const StyledTableCell = styled(TableCell)<StyledTableCellProps>(
  ({
    theme,
    minWidth = "150px",
    textAlign = "left",
    backgroundColor = "#FFFFFF",
    fontColor = "#343A40",
    hoverBackgroundColor,
    noBorderTop,
    noBorderBottom,
    noBorderRight,
    noBorderLeft,
  }) => ({
    boxSizing: "border-box",
    fontSize: "16px",
    fontWeight: 500,
    borderRight: noBorderRight
      ? "none"
      : `0.5px solid ${theme.palette.divider}`,
    borderTop: noBorderTop ? "none" : `0.5px solid ${theme.palette.divider}`,
    borderBottom: noBorderBottom
      ? "none"
      : `1px solid ${theme.palette.divider} !important`,
    borderLeft: noBorderLeft ? "none" : `0.5px solid ${theme.palette.divider}`,
    color: fontColor,
    minWidth: minWidth,
    textAlign: textAlign,
    "&:hover": hoverBackgroundColor
      ? {
          backgroundColor: hoverBackgroundColor,
        }
      : {},
  }),
);

const StyledTableHeadCell = styled(TableCell)<StyledTableCellProps>(
  ({
    theme,
    textAlign = "center",
    noBorderTop,
    noBorderBottom,
    noBorderRight,
    fontSize,
    fontWeight = 500,
    minWidth = "9.375 rem",
  }) => ({
    borderRight: noBorderRight
      ? "none"
      : `0.5px solid ${theme.palette.divider}`,
    borderTop: noBorderTop ? "none" : `0.5px solid ${theme.palette.divider}`,
    borderBottom: noBorderBottom
      ? "none"
      : `0.5px solid ${theme.palette.divider}`,
    fontSize: fontSize,
    color: "#343A40",
    backgroundColor: "#ECEFF3 ",
    textAlign: textAlign,
    fontWeight: fontWeight,
    minWidth: minWidth,
  }),
);

export default StyledTableHeadCell;

const StickyTableCell = styled(StyledTableCell)({
  padding: "4px 12px 4px 12px",
  position: "sticky",
  left: 0,
  zIndex: 1,
  cursor: "pointer",
  boxSizing: "border-box",
  backgroundColor: "#FFFFFF !important",
  "&:hover": {
    backgroundColor: "#DDE2E6 !important",
  },
});

const StickyTableHeadCell = styled(StyledTableHeadCell)({
  position: "sticky",
  left: 0,
  zIndex: 4,
});

const StickySecondaryTableHeadCell = styled(StyledTableHeadCell)({
  position: "sticky",
  left: 0,
});

const StyledSecondRowTableHeadCell = styled(StyledTableHeadCell)(
  ({ theme, textAlign = "center" }) => ({
    top: "30px",
    zIndex: 3,
  }),
);

export {
  StickyTableCell,
  StyledSecondRowTableHeadCell,
  StyledTableHeadCell,
  StickyTableHeadCell,
  StyledTableCell,
  StickySecondaryTableHeadCell,
  StyledInnerTableRow,
};
